var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article.article_variants.length)?_c('b-button',{attrs:{"id":"btn_actualizar_stock_variants","variant":"primary"},on:{"click":_vm.actualizar}},[_vm._v(" Actualizar Stock ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }